<template>
	<div>
		<SearchableTable :panel-header="'Nutzer'" :panel-route="'AddUser'" :show-search-bar="true" :table-data="staffUsers"
			:table-meta-data="tableMetaData" :query-string="'setUserSearchQuery'"
			:initial-search-query="userSearchQuery"
			:row-click="triggerView"
			:default-sort="['attributes.email', 'asc']" />
	</div>
</template>

<script>

/**
 * This file shows all currently stored users and allows adding and viewing
 * users; editing and deleting happens on the view page.
 */

import { mapGetters } from "vuex";
import SearchableTable from "../helperComponents/SearchableTable.vue";

export default {
	name: "UsersComponent",
	components: { SearchableTable },
	data() {
		return {
			tableMetaData: [
				{ "id": 0, "type": "string", "label": "Email", "field": "email", "sortField": "attributes.email" },
				{ "id": 1, "type": "string", "label": "Vorname", "field": "first_name", "sortField": "attributes.first_name" },
				{ "id": 2, "type": "string", "label": "Nachname", "field": "last_name", "sortField": "attributes.last_name" },
				{ "id": 3, "type": "boolean", "label": "", "field": "is_admin", "true": "Admin", "false": "" },
			]
		};
	},
	computed: {
		...mapGetters({
			staffUsers: "getStaffUserMetasFiltered",
			userSearchQuery: "getUserSearchQuery"
		})
	},
	methods: {
		triggerView(user) {
			this.$router.push(
				{ name: "ViewUser", params: { id: user.id, data: user } });
		}
	},
};
</script>

<style lang="scss"></style>
